export default "__VITE_ASSET__DE2rqksz__"